import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAccountLocationData as GetAccountLocationDataQuery,
    GetAccountLocationDataVariables,
    GetAccountLocationData_account_postalAddresses_primary_location as AccountLocationData,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_LOCATION_DATA from '../queries/get-account-location-data.graphql';

export function useGetAccountLocationData(
    accountId: string,
    skip: boolean = false
): {
    accountLocationData: AccountLocationData | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetAccountLocationDataQuery,
        GetAccountLocationDataVariables
    >(GET_ACCOUNT_LOCATION_DATA, {
        variables: {id: accountId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        accountLocationData: data?.account?.postalAddresses?.primary?.location ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
